import { apiClient } from '../shared/api-client';

const orderRepository = {
    async buyUpsell(body) {
        try {
            const status = await apiClient.post({
                url: 'orders/upsell',
                body
            });

            return status;
        } catch (error) {
            console.error(error);
        }
    },

    async create(body) {
        const data = await apiClient.post({
            url: 'orders',
            body
        });

        return data;
    }
};

export {
    orderRepository
};
